import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "doc-back",
  "use": "doc-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"doc-back\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.75932 12.0003L16.3293 5.3766L15.6708 4.62402L7.67077 11.624L7.24072 12.0003L7.67077 12.3766L15.6708 19.3766L16.3293 18.624L8.75932 12.0003Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol